export default "__VITE_ASSET__7cf07c90__"